import { NotifyHelper } from "../../../helpers/toast";
import { eKhoaActionsObj } from "../../action-types/category/IKhoaActions";
import { generateActionForKey, generateActions } from "../generateActions";

export const khoaActions = {
  ...generateActions(eKhoaActionsObj, "KHOA"),
  ...generateActionForKey(eKhoaActionsObj, "KHOA", "SAVE_SUCCESS", () => {
    NotifyHelper.Success("Thành công");
  }),
  ...generateActionForKey(eKhoaActionsObj, "KHOA", "DELETE_SUCCESS", () => {
    NotifyHelper.Success("Thành công");
  }),
  ...generateActionForKey(eKhoaActionsObj, "KHOA", "SAVE_ERRR", (m) => {
    NotifyHelper.Error(m);
  }),
  ...generateActionForKey(eKhoaActionsObj, "KHOA", "DELETE_ERRR", (m) => {
    NotifyHelper.Error(m);
  }),
};
